// stores/business/businessSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { localBusiness } from "../../data";

// Business details ship with the app; there is no lookup to perform.
const initialState = {
  businessId: String(localBusiness.id),
  businessInfo: localBusiness,
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {},
});

export default businessSlice.reducer;
